export const GET_IMAGE_WITH_PROPERTY = 'GET_IMAGE_WITH_PROPERTY';
export const ADD_IMAGE_PROPERTY = 'ADD_IMAGE_PROPERTY';
export const REMOVE_IMAGE_PROPERTY = 'REMOVE_IMAGE_PROPERTY';
export const CURRENT_IMAGE_WITH_PROPERTY = 'CURRENT_IMAGE_WITH_PROPERTY';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';

//Image Property Types
export const UPDATE_PROPERTY_TEXT = 'UPDATE_PROPERTY_TEXT';
export const UPDATE_FONT_FAMILY = 'UPDATE_FONT_FAMILY';
export const UPDATE_FONT_SIZE = 'UPDATE_FONT_SIZE';
export const UPDATE_LINE_HEIGHT = 'UPDATE_LINE_HEIGHT';
export const UPDATE_FONT_COLOR = 'UPDATE_FONT_COLOR';
export const UPDATE_LETTER_SPACING = 'UPDATE_LETTER_SPACING';
export const UPDATE_TEXT_ALIGNMENT = 'UPDATE_TEXT_ALIGNMENT';
export const UPDATE_PROPERTY_TRANSLATION = 'UPDATE_PROPERTY_TRANSLATION';
export const SAVE_IMAGE_PROPERTIES = 'SAVE_IMAGE_PROPERTIES';
export const UPDATE_TEXTAREA_SIZE = 'UPDATE_TEXTAREA_SIZE';
export const UPDATE_IMAGE_SIZE = 'UPDATE_IMAGE_SIZE';
export const UPDATE_PHOTO_HOLDER_SIZE = 'UPDATE_PHOTO_HOLDER_SIZE';
export const UPDATE_PHOTO = 'UPDATE_PHOTO';
export const UPDATE_BACKGROUND_COLOR = 'UPDATE_BACKGROUND_COLOR';
export const UPDATE_BOX_ROTATION = 'UPDATE_BOX_ROTATION';
export const UPDATE_TEXT_STROKE = 'UPDATE_TEXT_STROKE';
export const REMOVE_PHOTO = 'REMOVE_PHOTO';

